module.exports = __webpack_public_path__ + "media/packs/images/flags/TN-e3b48d44ce08652c6d0dc757278efcf3.svg";